import React, {useEffect} from 'react';
import {Button, Card, Col, Dropdown, Form, Modal, Spinner, Table} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import {toast} from "react-toastify";
import {updateUserDataAdminFront, userBalanceChangeApi, userVirtBalanceChangeApi} from "../../http/userAPI";
import { fetchUserLogs, getLinkedByUserApi } from "../../http/userLogAPI";
import {fetchAssignmentsAdmin, fetchBooksWithParams} from "../../http/bookAPI";

const EditUserAdmin = ({
    show,
    handleClose,
    userInfo,
    onOpenUserBooks,
    onOpenUserAuthorAssignments,
    onOpenUserReviewerAssignments,
}) => {
    const [selectedStatus, setSelectedStatus] = React.useState("");
    const [logs, setLogs] = React.useState([]);
    const [logLoading, setLogLoading] = React.useState(false);
    const [userAmountVirt, setUserAmountVirt] = React.useState(0);
    const [userAmountUsd, setUserAmountUsd] = React.useState(0);
    const [userAmountTrust, setUserAmountTrust] = React.useState(0);
    const [userAmountAff, setUserAmountAff] = React.useState(0);
    const [userRevName, setUserRevName] = React.useState(null);
    const [userAudibleRevName, setUserAudibleRevName] = React.useState(null);
    const [selectedAmazonSite, setSelectedAmazonSite] = React.useState("");
    const [selectedAudibleSite, setSelectedAudibleSite] = React.useState("");
    const [killHold, setKillHold] = React.useState(false);
    const [promoCode, setPromoCode] = React.useState(false);
    const [coolPartner, setCoolPartner] = React.useState(false);
    const [messageLog, setMessageLog] = React.useState("");
    const [amazonAttempts, setAmazonAttempts] = React.useState(userInfo.amazon_rn_changes);
    const [audibleAttempts, setAudibleAttempts] = React.useState(userInfo.audible_rn_changes);

    const [linked, setLinked] = React.useState(null);     // полный ответ сервера
    const [linkedLoading, setLinkedLoading] = React.useState(false);
    const [linkedError, setLinkedError] = React.useState(null);
    const [activeInspector, setActiveInspector] = React.useState(null);
    const [inspectorRows, setInspectorRows] = React.useState([]);
    const [inspectorCount, setInspectorCount] = React.useState(0);
    const [inspectorLoading, setInspectorLoading] = React.useState(false);
    const [inspectorError, setInspectorError] = React.useState("");



    const statusOptions = ["FREE", "ESSENTIAL", "PREMIUM", "MAXIMUM", "SUSPENDED"];
    const amazonSites = [
        { code: "US", url: "https://www.amazon.com", label: "Amazon USA" },
        { code: "UK", url: "https://www.amazon.co.uk", label: "Amazon UK" },
        { code: "CA", url: "https://www.amazon.ca", label: "Amazon Canada" },
        { code: "DE", url: "https://www.amazon.de", label: "Amazon Germany" },
        { code: "FR", url: "https://www.amazon.fr", label: "Amazon France" },
        { code: "IT", url: "https://www.amazon.it", label: "Amazon Italy" },
        { code: "ES", url: "https://www.amazon.es", label: "Amazon Spain" },
        { code: "JP", url: "https://www.amazon.co.jp", label: "Amazon Japan" },
        { code: "AU", url: "https://www.amazon.com.au", label: "Amazon Australia" },
        { code: "IN", url: "https://www.amazon.in", label: "Amazon India" },
        { code: "MX", url: "https://www.amazon.com.mx", label: "Amazon Mexico" },
        { code: "BR", url: "https://www.amazon.com.br", label: "Amazon Brazil" },
        { code: "CN", url: "https://www.amazon.cn", label: "Amazon China" },
    ];

    const audibleSites = [
        { code: "AUS", url: "https://www.audible.com", label: "Audible USA" },
        { code: "AUK", url: "https://www.audible.co.uk", label: "Audible UK" },
    ];

    const handleSiteChange = (event) => {
        setSelectedAmazonSite(event.target.value);
    };
    const handleAudioSiteChange = (event) => {
        setSelectedAudibleSite(event.target.value);
    };


    const internalClose = () => {
        setSelectedStatus("");
        handleClose();
        setLogs([]);
        setUserRevName("");
        setUserAudibleRevName("");
        setUserAmountVirt(0);
        setUserAmountTrust(0);
        setUserAmountUsd(0);
        setUserAmountAff(0);
        setSelectedAmazonSite("");
        setSelectedAudibleSite("");
        setKillHold(false);
        setPromoCode(false);
        setCoolPartner(false);
        // + NEW
        setLinked(null);
        setLinkedError(null);
        setLinkedLoading(false);
        setActiveInspector(null);
        setInspectorRows([]);
        setInspectorCount(0);
        setInspectorLoading(false);
        setInspectorError("");
    }

    const closeAndOpenSearch = (handler) => {
        const id = userInfo?.id;
        internalClose();
        if (id && typeof handler === "function") {
            handler(id);
        }
    };

    const getLinked = async () => {
        try {
            setLinkedLoading(true);
            setLinkedError(null);
            setActiveInspector(null);
            setInspectorRows([]);
            setInspectorCount(0);
            setInspectorError("");
            setLogs([]);
            const resp = await getLinkedByUserApi(userInfo.id, {
                lookbackDays: 90,
                minSignals: 2,
                includeGuests: false,
                excludeNulls: true,
                page: 1,
                limit: 50,
            });
            setLinked(resp);
            if ((resp?.total_matches ?? 0) === 0) {
                toast.info("No linked accounts found in the selected window.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            }
        } catch (e) {
            const msg = e?.response?.data?.message || "Failed to fetch linked accounts";
            setLinkedError(msg);
            toast.error(msg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLinkedLoading(false);
        }
    };

    const clearLinked = () => {
        setLinked(null);
        setLinkedError(null);
        setLinkedLoading(false);
       setLogs([]);
        setActiveInspector(null);
        setInspectorRows([]);
        setInspectorCount(0);
        setInspectorError("");
    };

    const getAssignmentRows = (response) => {
        if (Array.isArray(response?.items)) return response.items;
        if (Array.isArray(response?.assignments)) return response.assignments;
        return [];
    };

    const loadInspector = async (mode) => {
        if (!userInfo?.id) return;

        setActiveInspector(mode);
        setInspectorRows([]);
        setInspectorCount(0);
        setInspectorError("");
        setLogs([]);
        setLinked(null);
        setLinkedError(null);

        try {
            setInspectorLoading(true);
            if (mode === "books") {
                const response = await fetchBooksWithParams({
                    ownerId: userInfo.id,
                    page: 1,
                    limit: 100,
                });
                const rows = Array.isArray(response?.items) ? response.items : [];
                setInspectorRows(rows);
                setInspectorCount(Number(response?.count || rows.length || 0));
                if (!rows.length) setInspectorError("No books or products found for this user.");
                return;
            }

            const params = {
                page: 1,
                limit: 100,
                ...(mode === "authorAssignments"
                    ? { ownerId: userInfo.id }
                    : { reviewer_id: userInfo.id }),
            };
            const response = await fetchAssignmentsAdmin(params);
            const rows = getAssignmentRows(response);
            setInspectorRows(rows);
            setInspectorCount(Number(response?.count || rows.length || 0));
            if (!rows.length) {
                setInspectorError(mode === "authorAssignments"
                    ? "No assignments where this user is the author."
                    : "No assignments where this user is the reviewer.");
            }
        } catch (e) {
            const message = e?.response?.data?.message || e?.message || "Failed to load user data.";
            setInspectorError(message);
            toast.error(message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setInspectorLoading(false);
        }
    };


    const getLogs = async () => {
        try {
            setLogLoading(true);
            setActiveInspector(null);
            setInspectorRows([]);
            setInspectorCount(0);
            setInspectorError("");
            setLinked(null);
            setLinkedError(null);
            const logs = await fetchUserLogs(userInfo.id); // или userInfo.id
            setLogs(logs); // см. следующий шаг
            setLogLoading(false);
        } catch (error) {
            console.error('Error fetching logs:', error);
        } finally {
            setLogLoading(false);
        }
    };

    const handleClick = async () => {
        try {
            const virtAmount  = Number(userAmountVirt)  || 0;
            const usdAmount   = Number(userAmountUsd)   || 0;
            const trustAmount = Number(userAmountTrust) || 0;
            const affAmount   = Number(userAmountAff)   || 0;

            const values = [virtAmount, usdAmount, trustAmount, affAmount];

            const hasAnyValue = values.some(
                (v) => !isNaN(v) && v !== 0
            );

            if (!hasAnyValue) {
                alert("Please enter at least one non-zero value");
                return;
            }

            const response = await userBalanceChangeApi(
                userInfo.id,
                virtAmount,
                usdAmount,
                trustAmount,
                affAmount,
                messageLog
            );

            toast.info(response.message || "Data Updated Successfully", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            setUserAmountVirt(0);
            setUserAmountUsd(0);
            setUserAmountTrust(0);
            setUserAmountAff(0);

        } catch (e) {
            toast.error(
                e.response?.data?.message || "Failed to Change",
                { position: "bottom-center", autoClose: 3000, hideProgressBar: false }
            );
        } finally {
            setMessageLog("");
        }
    };


    const handleSaveChanges = async () => {
        try {
            const updatedData = {
                id: userInfo.id,
                tariff_plan: selectedStatus,
                amz_name: userRevName,  // Обновлённое поле
                amz_country: selectedAmazonSite,  // Обновлённое поле
                audible_name: userAudibleRevName,  // Обновлённое поле
                audible_country: selectedAudibleSite,  // Обновлённое поле
                hold_start_date: killHold,
                is_referrer_have_promo_code: promoCode,
                do_you_cool_partner: coolPartner,
                amazon_rn_changes: amazonAttempts,
                audible_rn_changes: audibleAttempts,
            };



            await updateUserDataAdminFront(updatedData);

            toast.success("User updated!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } catch (error) {
            toast.error("Failed to update", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            console.error("Error updating:", error);
        }
    };


    useEffect(() => {
        if (!show || !userInfo?.id) return;
        setSelectedStatus(userInfo.tariff_plan);
        setUserRevName(userInfo.amz_name);
        setUserAudibleRevName(userInfo.audible_name);
        setSelectedAmazonSite(userInfo.amz_country);
        setSelectedAudibleSite(userInfo.audible_country);
        setCoolPartner(userInfo.do_you_cool_partner);
        setPromoCode(userInfo.is_referrer_have_promo_code);
        setKillHold(userInfo.hold_start_date === null);
        setAmazonAttempts(userInfo.amazon_rn_changes || 0);
        setAudibleAttempts(userInfo.audible_rn_changes || 0);
        setActiveInspector(null);
        setInspectorRows([]);
        setInspectorCount(0);
        setInspectorError("");

    }, [show, userInfo?.id]);

    const shortText = (value, max = 42) => {
        const text = String(value || "");
        return text.length > max ? `${text.slice(0, max)}...` : text || "N/A";
    };

    const formatMinutesDate = (minutes) => {
        if (!minutes && minutes !== 0) return "N/A";
        const date = new Date(Number(minutes) * 60000);
        if (Number.isNaN(date.getTime())) return "N/A";
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const inspectorTitle = {
        books: "Books and Products",
        authorAssignments: "Assignments as Author",
        reviewerAssignments: "Assignments as Reviewer",
    }[activeInspector];

    return (
        <Modal show={show} size="xl" onHide={internalClose} top>
            <Modal.Header closeButton>
                <div className="d-flex align-items-center justify-content-between gap-3 w-100">
                    <Modal.Title>User ID: {userInfo?.id}</Modal.Title>
                    <div className="d-flex flex-wrap gap-2 me-3 justify-content-end">
                        <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => closeAndOpenSearch(onOpenUserBooks)}
                        >
                            Books / Products
                        </Button>
                        <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => closeAndOpenSearch(onOpenUserAuthorAssignments)}
                        >
                            Author Assignments
                        </Button>
                        <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => closeAndOpenSearch(onOpenUserReviewerAssignments)}
                        >
                            Reviewer Assignments
                        </Button>
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body>


                <Row className="small mt-3 mb-2">
                    <Col md={6} className="justify-content-start">
                        <table className="table table-sm w-100 border shadow-lg table-striped text-muted">
                            <thead>
                            <tr>
                                <th className="ps-2">Parameter</th>
                                <th className="ps-2">User Data</th>
                            </tr>
                            </thead>
                            <tbody>
                            {[
                                ["Balance", "balance"],
                                ["Username", "username"],
                                ["Email", "email"],
                                ["Role", "role"],
                                ["Amazon Name", "amz_name"],
                                ["Amazon Country", "amz_country"],
                                ["Audible Name", "audible_name"],
                                ["Audible Country", "audible_country"],
                                ["Registration Date", "registration_date"],
                                ["Tariff Plan", "tariff_plan"],
                                ["Assignment Limit", "assignment_limit"],
                                ["Level of Trust", "level_of_trust"],
                                ["Books", "bookCount"],
                                ["Assignments", "assignmentCount"],
                                ["Taken Assignments", "takenAssignmentsCount"],
                                ["Is Referrer Have Promo Code", "is_referrer_have_promo_code"],
                                ["Do You Cool Partner", "do_you_cool_partner"],
                                ["Hold Start Date", "hold_start_date"],
                            ].map(([label, key]) => {
                                const rawValue = userInfo?.[key];

                                let displayValue = rawValue;

                                // Булевые значения
                                if (typeof rawValue === "boolean") {
                                    displayValue = rawValue ? "✅ Yes" : "❌ No";
                                }

                                // Для Registration Date — храним в минутах, показываем с временем
                                if (key === "registration_date" && rawValue) {
                                    const date = new Date(rawValue * 60000); // Преобразуем из секунд в миллисекунды
                                    displayValue = date.toLocaleString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    });
                                }

                                // Для Hold Start Date — выводим только дату
                                if (key === "hold_start_date" && rawValue) {
                                    const date = new Date(rawValue); // Используем миллисекунды
                                    displayValue = date.toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    });
                                }

                                return (
                                    <tr key={key} className="fst-italic" style={{ lineHeight: "1", padding: "2px 0" }}>
                                        <td className="ps-2">{label}</td>
                                        <td className="ps-2">{displayValue || "—"}</td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </Col>

                    <Col md={6} className="justify-content-start" >
                        <Card className="border-0 shadow-sm">
                            <Card.Body className="d-flex flex-column align-items-center">
                                <h5>Manual User Editing:</h5>

                                <Form>
                                    <Row className="mb-3">
                                        <Form className="d-flex gap-3 align-items-end flex-wrap">
                                            {/* Amazon Reviewer Name */}
                                            <Form.Group>
                                                <Form.Label className="small mb-1">Amazon Reviewer</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    className="form-control-sm border-secondary"
                                                    placeholder="AMZ Reviewer"
                                                    value={userRevName}
                                                    onChange={(e) => setUserRevName(e.target.value)}
                                                />
                                            </Form.Group>

                                            {/* Amazon Site */}
                                            <Form.Group>
                                                <Form.Label className="small mb-1">Amazon Site</Form.Label>
                                                <Form.Select
                                                    id="amazonSites"
                                                    name="amz_country"
                                                    value={selectedAmazonSite}
                                                    onChange={handleSiteChange}
                                                    className="form-select form-select-sm border-secondary"
                                                    style={{ width: "150px" }}
                                                >
                                                    <option value="" disabled>Amazon Site</option>
                                                    {amazonSites.map((site) => (
                                                        <option key={site.code} value={site.url}>
                                                            {site.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>

                                            {/* Amazon RN Attempts */}
                                            <Form.Group>
                                                <Form.Label className="small mb-1">Amazon RN Attempts</Form.Label>
                                                <Form.Select
                                                    size="sm"
                                                    value={amazonAttempts}
                                                    onChange={(e) => setAmazonAttempts(Number(e.target.value))}
                                                    className="border-secondary"
                                                    style={{ width: "120px" }}
                                                >
                                                    {[0, 1, 2, 3].map((num) => (
                                                        <option key={num} value={num}>{num}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Form>
                                    </Row>

                                    <Row className="mb-3">
                                        <Form className="d-flex gap-3 align-items-end flex-wrap">
                                            {/* Audible Reviewer Name */}
                                            <Form.Group>
                                                <Form.Label className="small mb-1">Audible Reviewer</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    className="form-control-sm border-secondary"
                                                    placeholder="Audible Reviewer"
                                                    value={userAudibleRevName}
                                                    onChange={(e) => setUserAudibleRevName(e.target.value)}
                                                />
                                            </Form.Group>

                                            {/* Audible Site */}
                                            <Form.Group>
                                                <Form.Label className="small mb-1">Audible Site</Form.Label>
                                                <Form.Select
                                                    id="audibleSites"
                                                    name="audible_country"
                                                    value={selectedAudibleSite}
                                                    onChange={handleAudioSiteChange}
                                                    className="form-select form-select-sm border-secondary"
                                                    style={{ width: "150px" }}
                                                >
                                                    <option value="" disabled>Audible Site</option>
                                                    {audibleSites.map((site) => (
                                                        <option key={site.code} value={site.url}>
                                                            {site.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>

                                            {/* Audible RN Attempts */}
                                            <Form.Group>
                                                <Form.Label className="small mb-1">Audible RN Attempts</Form.Label>
                                                <Form.Select
                                                    size="sm"
                                                    value={audibleAttempts}
                                                    onChange={(e) => setAudibleAttempts(Number(e.target.value))}
                                                    className="border-secondary"
                                                    style={{ width: "120px" }}
                                                >
                                                    {[0, 1, 2, 3].map((num) => (
                                                        <option key={num} value={num}>{num}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Form>
                                    </Row>


                                    {/*<Row className="align-items-center mb-3">*/}
                                    {/*    <Form className="d-flex gap-4 flex-wrap">*/}
                                    {/*        <Form.Check*/}
                                    {/*            type="checkbox"*/}
                                    {/*            id="killHold"*/}
                                    {/*            label="Kill Hold"*/}
                                    {/*            checked={killHold}*/}
                                    {/*            onChange={(e) => setKillHold(e.target.checked)}*/}
                                    {/*            className="text-success"*/}
                                    {/*        />*/}

                                    {/*        <Form.Check*/}
                                    {/*            type="checkbox"*/}
                                    {/*            id="promoCode"*/}
                                    {/*            label="Promo Code"*/}
                                    {/*            checked={promoCode}*/}
                                    {/*            onChange={(e) => setPromoCode(e.target.checked)}*/}
                                    {/*            className="text-success"*/}
                                    {/*        />*/}

                                    {/*        <Form.Check*/}
                                    {/*            type="checkbox"*/}
                                    {/*            id="coolPartner"*/}
                                    {/*            label="Cool Partner"*/}
                                    {/*            checked={coolPartner}*/}
                                    {/*            onChange={(e) => setCoolPartner(e.target.checked)}*/}
                                    {/*            className="text-success"*/}
                                    {/*        />*/}





                                    {/*    </Form>*/}
                                    {/*</Row>*/}


                                    <Row className=" align-items-center">
                                        <Col xs="auto">
                                            <Form.Group>
                                                <Dropdown onSelect={(value) => setSelectedStatus(value)}>
                                                    <Dropdown.Toggle variant="secondary" size="sm">
                                                        {selectedStatus || userInfo?.tariff_plan}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {statusOptions.map((status) => (
                                                            <Dropdown.Item key={status} eventKey={status}>
                                                                {status}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </Form.Group>
                                        </Col>

                                        <Col xs="auto">
                                            <Form.Group>
                                                <Button variant="outline-success" size="sm" onClick={handleSaveChanges}>
                                                    Apply Changes
                                                </Button>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                  </Form>

                                <Row className="align-items-end g-3 mt-1 flex-wrap">
                                  <span className="me-2">
    <h6>
        Change Virt / USD / Trust / Aff - User ID: {userInfo.id}, AN: {userInfo.amz_name}
    </h6>

                                      {userInfo.email},
    Virt: <span className="fw-semibold">{Number(parseFloat(userInfo.balance) || 0).toFixed(0)}</span>,
    USD: <span className="fw-semibold">${Number(parseFloat(userInfo.lr_balance) || 0).toFixed(2)}</span>,
    Trust: <span className="fw-semibold">{userInfo.level_of_trust}</span>,
    Aff: <span className="fw-semibold">${Number(parseFloat(userInfo.affiliate_balance) || 0).toFixed(2)}</span>
</span>
                                    <Col xs="auto">
                                        <label className="form-label small mb-0">Virt</label>
                                        <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            style={{ width: "100px" }}
                                            value={userAmountVirt}
                                            onChange={(e) => setUserAmountVirt(e.target.value)}
                                        />
                                    </Col>
                                        <Col xs="auto">
                                        <label className="form-label small mb-0">Trust</label>
                                        <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            style={{ width: "100px" }}
                                            value={userAmountTrust}
                                            onChange={(e) => setUserAmountTrust(e.target.value)}
                                        />
                                        </Col>
                                    <Col xs="auto">
                                        <label className="form-label small mb-0">USD</label>
                                        <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            style={{ width: "100px" }}
                                            value={userAmountUsd}
                                            onChange={(e) => setUserAmountUsd(e.target.value)}
                                        />
                                    </Col>
                                    <Col xs="auto">
                                        <label className="form-label small mb-0">Aff USD</label>
                                        <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            style={{ width: "100px" }}
                                            value={userAmountAff}
                                            onChange={(e) => setUserAmountAff(e.target.value)}
                                        />
                                    </Col>
                                </Row>
                                <Row className="align-items-end justify-content-between g-3 mt-0">
                                    <Col xs="auto">
                                        <label className="form-label small mb-0">Message</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            style={{ width: "380px" }}
                                            value={messageLog}
                                            onChange={(e) => setMessageLog(e.target.value)}
                                        />
                                    </Col>

                                    <Col xs="auto" className="pt-2">
                                        <button
                                            className="btn btn-outline-success btn-sm mt-1"
                                            onClick={handleClick}
                                        >
                                           Apply Changes
                                        </button>
                                    </Col>
                                </Row>





                            </Card.Body>
                        </Card>
                    </Col>
                </Row>





                <div className="d-flex gap-2 my-0 flex-wrap">
                    <Button variant="secondary" size="sm" onClick={getLogs}>
                        {logLoading ? (
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        ) : null}
                        Get Logs
                    </Button>

                    {/* + NEW: Anti-Fraud */}
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={getLinked}
                        disabled={linkedLoading}
                        title="Find intersections by device/browser/IP/fingerprint"
                    >
                        {linkedLoading ? (
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        ) : null}
                        Check Linked (Anti-Fraud)
                    </Button>

                    <Button
                        variant={activeInspector === "books" ? "success" : "outline-success"}
                        size="sm"
                        onClick={() => loadInspector("books")}
                        disabled={inspectorLoading && activeInspector === "books"}
                        title="Show this user's books and products"
                    >
                        {inspectorLoading && activeInspector === "books" ? <Spinner size="sm" className="me-1" /> : null}
                        Books / Products
                    </Button>

                    <Button
                        variant={activeInspector === "authorAssignments" ? "success" : "outline-success"}
                        size="sm"
                        onClick={() => loadInspector("authorAssignments")}
                        disabled={inspectorLoading && activeInspector === "authorAssignments"}
                        title="Show assignments where this user is the author"
                    >
                        {inspectorLoading && activeInspector === "authorAssignments" ? <Spinner size="sm" className="me-1" /> : null}
                        Author Assignments
                    </Button>

                    <Button
                        variant={activeInspector === "reviewerAssignments" ? "success" : "outline-success"}
                        size="sm"
                        onClick={() => loadInspector("reviewerAssignments")}
                        disabled={inspectorLoading && activeInspector === "reviewerAssignments"}
                        title="Show assignments where this user is the reviewer"
                    >
                        {inspectorLoading && activeInspector === "reviewerAssignments" ? <Spinner size="sm" className="me-1" /> : null}
                        Reviewer Assignments
                    </Button>

                    {/* + NEW: Clear */}
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={clearLinked}
                        disabled={!linked && !logs.length && !activeInspector}
                        title="Clear visible user details"
                    >
                        Clear
                    </Button>
                </div>

                {activeInspector && (
                    <div className="mt-3">
                        <h6 className="mb-2">
                            {inspectorTitle}
                            <span className="ms-2 text-muted small">
                                User ID: {userInfo?.id} | Total: {inspectorCount}
                            </span>
                        </h6>

                        {inspectorLoading ? (
                            <div className="d-flex align-items-center gap-2 small text-muted">
                                <Spinner size="sm" /> Loading...
                            </div>
                        ) : inspectorError ? (
                            <div className="alert alert-light border mt-2 py-2 px-3 small">
                                {inspectorError}
                            </div>
                        ) : activeInspector === "books" ? (
                            <div style={{ overflowX: "auto", whiteSpace: "nowrap", paddingBottom: 6 }}>
                                <Table bordered hover size="sm" striped className="mt-1" style={{ minWidth: 760 }}>
                                    <thead className="table-light small">
                                    <tr className="small">
                                        <th className="small">BID</th>
                                        <th className="small">Title</th>
                                        <th className="small">Status</th>
                                        <th className="small">Type</th>
                                        <th className="small">Ass</th>
                                        <th className="small">Words</th>
                                        <th className="small">Formats</th>
                                        <th className="small">Price</th>
                                        <th className="small">Updated</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {inspectorRows.map((book) => {
                                        const formats = [
                                            book.kindle_flag ? "K" : null,
                                            book.kindle_unlimited_flag ? "KU" : null,
                                            book.paper_back_flag ? "PB" : null,
                                            book.hard_cover_flag ? "HC" : null,
                                            book.audio_flag ? "AU" : null,
                                        ].filter(Boolean).join(", ") || "N/A";

                                        return (
                                            <tr key={`book-${book.id}`} className="small">
                                                <td className="small">{book.id}</td>
                                                <td className="small" title={book.title}>{shortText(book.title, 48)}</td>
                                                <td className="small">{book.status || "N/A"}</td>
                                                <td className="small">{book.book_type || "book"}</td>
                                                <td className="small text-center">{book.assCount ?? "N/A"}</td>
                                                <td className="small text-center">{book.total_words || "N/A"}</td>
                                                <td className="small">{formats}</td>
                                                <td className="small">{book.default_price || book.amz_price || "N/A"}</td>
                                                <td className="small">{book.updatedAt ? new Date(book.updatedAt).toLocaleDateString("en-GB") : "N/A"}</td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <div style={{ overflowX: "auto", whiteSpace: "nowrap", paddingBottom: 6 }}>
                                <Table bordered hover size="sm" striped className="mt-1" style={{ minWidth: 920 }}>
                                    <thead className="table-light small">
                                    <tr className="small">
                                        <th className="small">AID</th>
                                        <th className="small">Status</th>
                                        <th className="small">Check</th>
                                        <th className="small">BID</th>
                                        <th className="small">Title</th>
                                        <th className="small">OID</th>
                                        <th className="small">RID</th>
                                        <th className="small">Reviewer</th>
                                        <th className="small">Type</th>
                                        <th className="small">Start</th>
                                        <th className="small">Report</th>
                                        <th className="small">Confirm</th>
                                        <th className="small">Link</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {inspectorRows.map((assignment) => {
                                        const title = assignment.book?.title || assignment.book_title || assignment.title;
                                        const reviewerName = assignment.reviewer?.amz_name || assignment.reviewer_name;
                                        const assType = assignment.assType?.ass_type_name || assignment.ass_type_name || assignment.assTypeId;
                                        return (
                                            <tr key={`assignment-${assignment.id}`} className="small">
                                                <td className="small">{assignment.id}</td>
                                                <td className="small">{assignment.assignment_status || "N/A"}</td>
                                                <td className="small">{assignment.check_status || "N/A"}</td>
                                                <td className="small">{assignment.bookId || assignment.book?.id || "N/A"}</td>
                                                <td className="small" title={title}>{shortText(title, 44)}</td>
                                                <td className="small">{assignment.userId || assignment.owner?.id || "N/A"}</td>
                                                <td className="small">{assignment.reviewer_id || "N/A"}</td>
                                                <td className="small" title={reviewerName}>{shortText(reviewerName, 24)}</td>
                                                <td className="small">{assType || "N/A"}</td>
                                                <td className="small">{formatMinutesDate(assignment.start_read_date)}</td>
                                                <td className="small">{formatMinutesDate(assignment.publish_rev_date)}</td>
                                                <td className="small">{formatMinutesDate(assignment.end_rev_date)}</td>
                                                <td className="small">{assignment.review_link ? "Yes" : "No"}</td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                    </div>
                )}


                {/* + NEW: Anti-Fraud results */}
                {linkedError && (
                    <div className="alert alert-danger mt-3 py-2 px-3 small">
                        {linkedError}
                    </div>
                )}

                {linked && (
                    <div className="mt-3">
                        <h6 className="mb-2">
                            Anti-Fraud Matches:
                            <span className="ms-2 text-muted small">
        Source User: {linked.source_user_id} • Lookback: {linked.lookback_days} days • Min signals: {linked.min_signals} • Total: {linked.total_matches}
      </span>
                        </h6>

                        {/* Desktop table */}
                        <div className="d-none d-md-block">
                            <Table bordered hover size="sm" striped className="mt-1" style={{ minWidth: '600px' }}>
                                <thead className="table-light small">
                                <tr>
                                    <th className="text-nowrap small">ID</th>
                                    <th className="small">Username</th>
                                    <th>AMZ Name</th>
                                    <th>Matched Fields</th>
                                    <th className="text-nowrap small">Counts per Field</th>
                                    <th className="text-center small text-nowrap">Hits</th>
                                    <th className="text-nowrap small">First Seen</th>
                                    <th className="text-nowrap small">Last Seen</th>
                                    <th className="text-end small text-nowrap">Weight</th>
                                </tr>
                                </thead>
                                <tbody>
                                {(linked.results || []).map((r, idx) => {
                                    const counts = Object.entries(r.counts_per_field || {}).map(([k,v]) => `${k}: ${v}`).join(', ');
                                    return (
                                        <tr key={`${r.other_user_id ?? 'guest'}-${idx}`} className="small">
                                            <td className="text-nowrap small">{r.other_user_id ?? <span className="text-muted">guest</span>}</td>
                                            <td className="small">{r.user?.username || <span className="text-muted">—</span>}</td>
                                            <td className="small">{r.user?.amz_name || <span className="text-muted">—</span>}</td>
                                            <td className="small" style={{maxWidth: 260}}>
                                                <div className="text-truncate" title={(r.matched_fields || []).join(', ')}>
                                                    {(r.matched_fields || []).join(', ')}
                                                </div>
                                            </td>
                                            <td className="small" style={{maxWidth: 300}}>
                                                <div className="text-truncate" title={counts}>{counts}</div>
                                            </td>
                                            <td className="text-center small">{r.total_hits}</td>
                                            <td className="text-nowrap small">
                                                {new Date(r.first_seen_at).toLocaleString("en-GB", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" })}
                                            </td>
                                            <td className="text-nowrap small">
                                                {new Date(r.last_seen_at).toLocaleString("en-GB", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" })}
                                            </td>
                                            <td className="text-end small">{r.suspicion_weight}</td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </div>

                        {/* Mobile cards */}
                        <div className="d-block d-md-none">
                            {(linked.results || []).map((r, idx) => (
                                <div key={`${r.other_user_id ?? 'guest'}-m-${idx}`} className="card mb-2 shadow-sm border border-secondary small">
                                    <div className="card-body p-2">
                                        <div className="d-flex justify-content-between">
                                            <strong>Other ID:</strong> <span>{r.other_user_id ?? 'guest'}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>Username:</strong> <span>{r.user?.username || '—'}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>AMZ:</strong> <span>{r.user?.amz_name || '—'}</span>
                                        </div>
                                        <div className="mt-1">
                                            <strong>Fields:</strong>
                                            <div className="text-muted">{(r.matched_fields || []).join(', ') || '—'}</div>
                                        </div>
                                        <div className="mt-1">
                                            <strong>Counts:</strong>
                                            <div className="text-muted">
                                                {Object.entries(r.counts_per_field || {}).map(([k,v]) => `${k}: ${v}`).join(', ') || '—'}
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mt-1">
                                            <strong>Hits:</strong> <span>{r.total_hits}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mt-1">
                                            <strong>First:</strong>
                                            <span>{new Date(r.first_seen_at).toLocaleString("en-GB", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mt-1">
                                            <strong>Last:</strong>
                                            <span>{new Date(r.last_seen_at).toLocaleString("en-GB", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mt-1">
                                            <strong>Weight:</strong> <span>{r.suspicion_weight}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Empty state */}
                        {Array.isArray(linked.results) && linked.results.length === 0 && (
                            <div className="alert alert-light border mt-2 py-2 px-3 small">
                                No intersections found.
                            </div>
                        )}
                    </div>
                )}

                {logs.length > 0 && (
                    <div className="mt-3">
                        <h6>User Logs:</h6>

                        {/* Desktop table */}
                        <div className="d-none d-md-block">
                            <Table bordered hover size="sm" striped className="mt-1" style={{ minWidth: '600px' }}>
                                <thead className="table-light small">
                                <tr>
                                    <th className="small">ID</th>
                                    <th className="small">UID</th>
                                    <th className="small">AName</th>
                                    <th className="small">Amount</th>
                                    <th className="small">Balance</th>
                                    <th className="small">Description</th>
                                    <th className="small">Date</th>
                                    <th className="small">Type</th>
                                </tr>
                                </thead>
                                <tbody>
                                {logs.map((log) => (
                                    <tr key={log.id} className="small">
                                        <td className="small">{log.id}</td>
                                        <td className="small">{log.user_id}</td>
                                        <td className="text-nowrap small">{log.user_amz_name}</td>
                                        <td className="small">{log.amount}</td>
                                        <td className="small">{log.balance_state}</td>
                                        <td className="small">{log.description}</td>
                                        <td className="align-middle text-center small text-nowrap">
                                            {new Date(log.createdAt).toLocaleString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}
                                        </td>
                                        <td className="align-middle text-center small text-nowrap">
                                            {log.log_type}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>

                        {/* Mobile cards */}
                        <div className="d-block d-md-none">
                            {logs.map((log) => (
                                <div
                                    key={log.id}
                                    className="card mb-2 shadow-sm border border-secondary small"
                                >
                                    <div className="card-body p-2">
                                        <div className="d-flex justify-content-between">
                                            <strong>ID:</strong> <span>{log.id}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>UID:</strong> <span>{log.user_id}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>AName:</strong> <span>{log.user_amz_name}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>Amount:</strong> <span>{log.amount}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>Balance:</strong> <span>{log.balance_state}</span>
                                        </div>
                                        <div>
                                            <strong>Description:</strong>
                                            <div className="text-muted">{log.description}</div>
                                        </div>
                                        <div className="d-flex justify-content-between mt-1">
                                            <strong>Date:</strong>
                                            <span>
                {new Date(log.createdAt).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                })}
              </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>Type:</strong> <span>{log.log_type}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}



            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={internalClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditUserAdmin;
